import instance from '@apis/instance';
import {
    CreateInquiryRequest, CreateInquiryResponse,
    GetInquiriesParams, InquiryCommentRequest,
    InquiryResponse,
    InquiryRow,
} from '@models/inquiry';
import { InquiryTypeRow } from '@models/inquiry/inquiryType';
import { SliceResponse } from '@models/page';

class InquiryApi {
    static createInquiry(request: CreateInquiryRequest): Promise<CreateInquiryResponse> {
        return instance.post('/v0/inquiries', request);
    }

    static createComment(
        inquiryId: string,
        request: InquiryCommentRequest,
    ): Promise<never> {
        return instance.post(`/v0/inquiries/${inquiryId}/comment`, request);
    }

    static getInquiryTypes(): Promise<InquiryTypeRow[]> {
        return instance.get('/v0/inquiry-types');
    }

    static getInquiries(params: GetInquiriesParams) : Promise<SliceResponse<InquiryRow>> {
        return instance.get('/v0/inquiries', { params });
    }

    static getInquiry(inquiryId: string): Promise<InquiryResponse> {
        return instance.get(`/v0/inquiries/${inquiryId}`);
    }

    static closeInquiry(inquiryId: string): Promise<never> {
        return instance.patch(`/v0/inquiries/${inquiryId}/close`);
    }
}

export default InquiryApi;
